import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import 'lenis/dist/lenis.css';

// Seletores de overlays do PrimeVue que devem manter a rolagem nativa
const SELETORES_OVERLAY = '.p-dialog, .p-sidebar, .p-overlaypanel, .p-dropdown-panel, .p-multiselect-panel, .p-autocomplete-panel, .p-datepicker, .p-menu-overlay, .p-component-overlay';

export function setupLenis(app) {
  const lenis = new Lenis({
    lerp: 0.1,
    wheelMultiplier: 1,
    allowNestedScroll: true,
    // Calcula o limite a cada rolagem, pois o #app usa contain: size e o ResizeObserver não detecta o crescimento da página
    naiveDimensions: true,
    prevent: (node) => !!node.closest?.(SELETORES_OVERLAY),
    // Mantém a rolagem nativa com teclas modificadoras (ctrl/shift + scroll) e gestos horizontais, usados nas tabelas
    virtualScroll: ({ deltaX, deltaY, event }) => {
      if (event.ctrlKey || event.shiftKey || event.altKey || event.metaKey) return false;
      return Math.abs(deltaX) <= Math.abs(deltaY);
    },
  });

  // Sincroniza o Lenis com o ScrollTrigger do GSAP
  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((tempo) => lenis.raf(tempo * 1000));
  gsap.ticker.lagSmoothing(0);

  app.config.globalProperties.$lenis = lenis;
  app.provide('lenis', lenis);
}
